/**
 * 조회용 config
 */
let selectConfig = {
  auth: {
    login: {
      refresh: {
        url: "/api/auth/refresh"
      },
      valid: {
        url: "/api/auth/valid"
      }
    },
    userInfo: {
      url: "/api/auth/user/info",
      depts: {
        url: "/api/auth/user/info/depts"
      },
      users: {
        url: "/api/auth/user/info/users"
      },
      vendors: {
        url: "/api/auth/user/info/vendors"
      },
    },
  },
  system: {
    lang: {
      url: "/api/system/langs"
    }
  },
  main: {
    workPermit: {
      url: "/api/main/workPermit/map"
    },
    workPermits: {
      url: "/api/main/workPermit/map"
    },
    riskAssess: {
      url: "/api/main/processAssess"
    },
    imprRequest: {
      url: "/api/main/impr/request"
    },
    imprAction: {
      url: "/api/main/impr/action"
    },
    imprChart: {
      url: "/api/main/impr/chart"
    },
    law: {
      url: "/api/main/law"
    },
    patrolChart: {
      url: "/api/main/patrol"
    },
    workPermitStatus: {
      url: "/api/main/workPermit"
    },
    imprProgress: {
      url: "/api/main/impr/progress"
    },
    workProgress: {
      url: "/api/main/work/progress"
    },
    eduAttendees: {
      url: "/api/main/edu/attendees"
    },
    eduComplete: {
      url: "/api/main/edu/complete"
    },
    airChart: {
      url: "/api/main/env/airchart"
    },
    airDetail: {
      url: "/api/main/env/airdetail"
    },
  },
  com: {
    chem: {
      unit: {
        url: "/api/com/chemunitapi"
      }
    },
    revision: {
      getversion: '/api/com/revision'
    },
    upload: {
      fileList: {
        url: "/api/com/uploadedFiles"
      },
      fileInfo: {
        url: "/api/com/uploadedFile"
      },
      preview: {
        url: "/api/com/imageToByte"
      },
      previewParamTask: {
        url: "/api/com/imageToByte/task"
      },
      fileDown: {
        url: "/api/com/fileToByte"
      },
    },
    comments: {
      list: {
        url: "/api/com/comments"
      },
    },
    weeks: {
      list: {
        url: '/api/com/weeks'
      }
    },
    task: {
      url: '/api/com/tasks'
    }
  },
  devtool: {
    dbtables: {
      url: "/api/devtool/generators"
    },
    dbtable: {
      url: "/api/devtool/generator/{0}/{1}"
    }
  },
  psi: {
    diagramkind: {
      url: "/api/psi/diagramkinds"
    },
    diagram: {
      list: {
        url: "/api/psi/diagrams"
      },
      get: {
        url: "/api/psi/diagram/{0}"
      }
    },
    documentkind: {
      url: "/api/psi/documentkinds"
    },
    document: {
      list: {
        url: "/api/psi/documents"
      },
      get: {
        url: "/api/psi/document/{0}"
      }
    },
    hsl: {
      hazardmaterials: {
        url: "/api/psi/hsl/hazardmaterials",
        revision: "/api/psi/hsl/hazardmaterials/revision",
        revisionno: "/api/psi/hsl/hazardmaterials/revisionno",
      },
    },
    pfi: {
      power: {
        list: {
          url: "/api/psi/pfi/powers"
        },
        get: {
          url: "/api/psi/pfi/power/{0}"
        }
      },
      device: {
        list: {
          url: "/api/psi/pfi/devices"
        },
        get: {
          url: "/api/psi/pfi/device/{0}"
        },
        detail: {
          url: "/api/psi/pfi/device/{0}/{1}"
        }
      },
      pipegasket: {
        list: {
          url: "/api/psi/pfi/pipegaskets"
        },
        get: {
          url: "/api/psi/pfi/pipegasket/{0}"
        },
        substance: {
          list: {
            url: "/api/psi/pfi/pipegasket/substance/{0}"
          },
        },
      },
      valve: {
        list: {
          url: "/api/psi/pfi/valves"
        },
        get: {
          url: "/api/psi/pfi/valve/{0}"
        }
      },
    },
    pcd: {
      interlock: {
        list: {
          url: "/api/psi/pcd/interlocks"
        },
        get: {
          url: "/api/psi/pcd/interlock/{0}"
        }
      },
    },
    lbe: {
      fireproof: {
        list: {
          url: "/api/psi/lbe/fireproofs"
        },
        get: {
          url: "/api/psi/lbe/fireproof/{0}"
        }
      },
      fireequip: {
        list: {
          url: "/api/psi/lbe/fireequips"
        },
        get: {
          url: "/api/psi/lbe/fireequip/{0}"
        }
      },
      firedetect: {
        list: {
          url: "/api/psi/lbe/firedetects"
        },
        get: {
          url: "/api/psi/lbe/firedetect/{0}"
        }
      },
      gasalarm: {
        list: {
          url: "/api/psi/lbe/gasalarms"
        },
        get: {
          url: "/api/psi/lbe/gasalarm/{0}"
        }
      },
      localven: {
        list: {
          url: "/api/psi/lbe/localvens"
        },
        get: {
          url: "/api/psi/lbe/localven/{0}"
        }
      },
      wash: {
        list: {
          url: "/api/psi/lbe/washs"
        },
        get: {
          url: "/api/psi/lbe/wash/{0}"
        }
      },
      protect: {
        list: {
          url: "/api/psi/lbe/protects"
        },
        get: {
          url: "/api/psi/lbe/protect/{0}"
        },
        item: {
          list: {
            url: "/api/psi/lbe/protectitems/{0}"
          },
        }
      },
    }
  },
  sys: {
    appr: {
      type: {
        list: {
          url: "/api/sys/appr/types"
        },
        get: {
          url: "/api/sys/appr/type/{0}"
        }
      },
      line: {
        last: {
          url: "/api/sys/appr/lines/last"
        },
        list: {
          url: "/api/sys/appr/lines"
        },
      },
      list: {
        todo: {
          url: "/api/sys/appr/list/todo"
        },
        mycnt: {
          url: "/api/sys/appr/list/mycnt"
        },
      },
      info: {
        get: {
          url: "/api/sys/appr/info"
        },
      },
    },
    favorite: {
      list: {
        url: "/api/sys/favorites"
      },
    },
    menu: {
      list: {
        url: "/api/sys/men/menus"
      },
      dashboard: {
        url: "/api/sys/men/menu/dashboards"
      },
      get: {
        url: "/api/sys/men/menu/{0}"
      }
    },
    manual: {
      get: {
        url: "/api/sys/men/manual/{0}"
      }
    },
    userMenu: {
      list: {
        url: "/api/sys/auth/user/usermenus"
      },
      get: {
        url: "/api/sys/auth/user/usermenus/"
      },
      favorites: {
        url: "/api/sys/auth/user/favorite/menu/"
      }
    },
    code: {
      domain: {
        list: {
          url: "/api/sys/code/domains"
        }
      },
      group: {
        list: {
          url: "/api/sys/code/grps/{0}"
        }
      },
      usegroup: {
        list: {
          url: "/api/sys/code/usegrps"
        }
      },
      mst: {
        list: {
          url: "/api/sys/code/msts/{0}",
          attr: {
            url: "/api/sys/code/msts/{0}/{1}"
          },
          multi: {
            url: "/api/sys/code/msts/multi",
          }
        },
      }
    },
    stepper: {
      grp: {
        list: {
          url: "/api/sys/stepper/grps"
        },
        get: {
          url: "/api/sys/stepper/grp/{0}"
        }
      },
      mst: {
        list: {
          url: "/api/sys/stepper/msts/{0}"
        },
        get: {
          url: "/api/sys/stepper/mst/{0}/{1}"
        },
      }
    },
    sequence: {
      list: {
        url: "/api/sys/sequences"
      },
      get: {
        url: "/api/sys/sequence/{0}"
      },
      check: {
        url: "/api/sys/sequence/check/{0}"
      }
    },
    attach: {
      list: {
        url: "/api/sys/attachsettings"
      },
      get: {
        url: "/api/sys/attachsetting/{0}"
      },
      check: {
        url: "/api/sys/attachsetting/check/{0}"
      }
    },
    excelUpload: {
      list: {
        url: "/api/sys/excelUploadSettings"
      },
      get: {
        url: "/api/sys/excelUploadSetting/{0}"
      },
      check: {
        url: "/api/sys/excelUploadSetting/check/{0}"
      },
      template: {
        url: "/api/sys/excelUpload/template"
      },
    },
    batch: {
      list: {
        url: "/api/sys/batchsettings"
      },
      get: {
        url: "/api/sys/batchsetting/{0}"
      },
      check: {
        url: "/api/sys/batchsetting/check/{0}"
      }
    },
    env: {
      list: {
        url: "/api/sys/envs"
      },
      get: {
        url: "/api/sys/env/{0}"
      },
    },
    shortcut: {
      list: {
        url: "/api/sys/shortcuts"
      },
      get: {
        url: "/api/sys/shortcut"
      },
    },
    notice: {
      list: {
        url: "/api/sys/notices"
      },
      main: {
        url: "/api/sys/main/notices"
      },
      get: {
        url: "/api/sys/notice/{0}"
      },
    },
    defect: {
      list: {
        url: "/api/sys/defects"
      },
      get: {
        url: "/api/sys/defect"
      },
    },
    lbl: {
      mst: {
        list: {
          url: "/api/sys/label/msts"
        }
      },
      dtl: {
        list: {
          url: "/api/sys/label/dtls/{0}"
        },
        get: {
          url: "/api/sys/label/dtl/{0}"
        },
      }
    },
    msg: {
      mst: {
        list: {
          url: "/api/sys/msg/msts"
        }
      },
      dtl: {
        list: {
          url: "/api/sys/msg/dtls/{0}"
        },
        get: {
          url: "/api/sys/msg/dtl/{0}"
        },
      }
    },
    auth: {
      grp: {
        list: {
          url: "/api/sys/auth/grps"
        },
        get: {
          url: "/api/sys/auth/grp/{0}"
        }
      },
      menu: {
        list: {
          url: "/api/sys/auth/menus"
        },
      },
      dept: {
        list: {
          url: "/api/sys/auth/depts"
        },
      },
      user: {
        list: {
          url: "/api/sys/auth/users"
        },
      },
      deptauth: {
        list: {
          url: "/api/sys/auth/deptauths"
        },
      },
      userauth: {
        list: {
          url: "/api/sys/auth/userauths"
        },
      },
      plant: {
        dept: {
          list: {
            url: "/api/sys/auth/plant/depts"
          },
        },
        user: {
          list: {
            url: "/api/sys/auth/plant/users"
          },
        },
      },
    },
    log: {
      login: {
        list: {
          url: '/api/sys/log/logins'
        }
      },
      batch: {
        list: {
          url: '/api/sys/log/batches'
        }
      },
      menulog: {
        list: {
          url: "/api/sys/log/menulogs"
        },
      }
    }
  },
  ram: {
    dashboard: {
      plantInfo: {
        url : "/api/ram/dashboard/plant"
      },
      processAssess: {
        url : "/api/ram/dashboard/processAssess"
      },
      hazop: {
        url : "/api/ram/dashboard/hazopHistory"
      },
      kras: {
        url : "/api/ram/dashboard/krasHistory"
      },
      kpsr: {
        url : "/api/ram/dashboard/kpsrHistory"
      },
      checklist: {
        url : "/api/ram/dashboard/checklistHistory"
      },
    },
    safeHealSurvey: {
      list: {
        url: "/api/ram/safeHealSurvey"
      },
      print: {
        url: "/api/ram/safeHealSurvey/print"
      },
    },
    variable: {
      list: {
        url: "/api/ram/base/variables"
      },
      get: {
        url: "/api/ram/base/variable/{0}"
      },
    },
    variableCause: {
      list: {
        url: "/api/ram/base/variable/guidewords"
      },
    },
    matrix: {
      list: {
        url: "/api/ram/base/matrixs"
      },
      get: {
        url: "/api/ram/base/matrix/{0}"
      },
    },
    riskType: {
      list: {
        url: "/api/ram/base/riskTypes"
      },
      get: {
        url: "/api/ram/base/riskType/{0}"
      },
    },
    riskTypeCause: {
      list: {
        url: "/api/ram/base/riskType/causes"
      },
    },
    riskHazard: {
      list: {
        url: "/api/ram/base/riskHazards"
      },
      get: {
        url: "/api/ram/base/riskHazard/{0}"
      },
    },
    fmRiskHazard: {
      list: {
        url: "/api/ram/base/4mRiskHazards"
      },
      get: {
        url: "/api/ram/base/4mRiskHazard/{0}"
      },
    },
    assessPlan: {
      list: {
        url: "/api/ram/assess/plans"
      },
    },
    assessTeam: {
      list: {
        url: "/api/ram/assess/teams"
      },
    },
    assessConference: {
      list: {
        url: "/api/ram/assess/conferences"
      },
    },
    relatedDocument: {
      list: {
        url: "/api/ram/assess/relatedDocuments"
      },
      addData: {
        url: "/api/ram/assess/relatedDocument/addDatas"
      },
    },
    drawNode: {
      list: {
        url: "/api/ram/assess/drawNodes"
      },
    },
    assessSop: {
      list: {
        url: "/api/ram/assess/sopScenarios"
      },
    },
    kpsr: {
      get: {
        url: "/api/ram/kpsr/assess/plan/{0}"
      },
      print: {
        url: "/api/ram/kpsr/print/{0}"
      },
      targetProcess: {
        url: "/api/ram/kpsr/assess/target/processes/{0}"
      },
      scenario: {
        list: {
          url: "/api/ram/kpsr/scenarios"
        },
      },
      riskReduce: {
        list: {
          url: "/api/ram/kpsr/assess/riskReduce"
        },
      }
    },
    hazop: {
      get: {
        url: "/api/ram/hazop/assess/plan/{0}"
      },
      print: {
        url: "/api/ram/hazop/print/{0}"
      },
      targetProcess: {
        url: "/api/ram/hazop/assess/target/processes/{0}"
      },
      scenario: {
        list: {
          url: "/api/ram/hazop/scenarios"
        },
      },
      riskReduce: {
        list: {
          url: "/api/ram/hazop/assess/riskReduce"
        },
      }
    },
    checklist: {
      get: {
        url: "/api/ram/checklist/assess/plan/{0}"
      },
      print: {
        url: "/api/ram/checklist/print/{0}"
      },
      targetProcess: {
        url: "/api/ram/checklist/assess/target/processes/{0}"
      },
      scenario: {
        list: {
          url: "/api/ram/checklist/scenarios"
        },
      },
      riskReduce: {
        list: {
          url: "/api/ram/checklist/assess/riskReduce"
        },
      },
      drawNode: {
        list: {
          url: "/api/ram/checklist/assess/drawNodes"
        },
      },
      master: {
        list: {
          url: "/api/ram/checklist/masters"
        },
      }
    },
    jsa: {
      get: {
        url: "/api/ram/jsa/assess/plan/{0}"
      },
      print: {
        url: "/api/ram/jsa/print/{0}"
      },
      targetProcess: {
        url: "/api/ram/jsa/assess/target/processes/{0}"
      },
      scenario: {
        list: {
          url: "/api/ram/jsa/scenarios"
        },
      },
      riskReduce: {
        list: {
          url: "/api/ram/jsa/assess/riskReduce"
        },
      },
      riskRegister: {
        list: {
          url: "/api/ram/jsa/assess/riskRegister"
        },
      },
    },
    kras: {
      get: {
        url: "/api/ram/kras/assess/plan/{0}"
      },
      print: {
        url: "/api/ram/kras/print/{0}"
      },
      targetProcess: {
        url: "/api/ram/kras/assess/target/processes/{0}"
      },
      scenario: {
        list: {
          url: "/api/ram/kras/scenarios"
        },
      },
      riskReduce: {
        list: {
          url: "/api/ram/kras/assess/riskReduce"
        },
      }
    },
    fm: {
      get: {
        url: "/api/ram/4m/assess/plan/{0}"
      },
      print: {
        url: "/api/ram/4m/print/{0}"
      },
      targetProcess: {
        url: "/api/ram/4m/assess/target/processes/{0}"
      },
      scenario: {
        list: {
          url: "/api/ram/4m/scenarios"
        },
      },
      riskReduce: {
        list: {
          url: "/api/ram/4m/assess/riskReduce"
        },
      },
      riskRegister: {
        list: {
          url: "/api/ram/4m/assess/riskRegister"
        },
      },
      impr: {
        list: {
          url: "/api/ram/4m/assess/riskReduce/imprs"
        },
        get: {
          url: "/api/ram/4m/assess/riskReduce/impr/{0}"
        },
      },
    },
    charm: {
      get: {
        url: "/api/ram/charm/assess/plan/{0}"
      },
      print: {
        url: "/api/ram/charm/print/{0}"
      },
      targetProcess: {
        url: "/api/ram/charm/assess/target/processes/{0}"
      },
      scenario: {
        result: {
          url: "/api/ram/charm/result/scenarios"
        },
        estimation: {
          url: "/api/ram/charm/estimation/scenarios"
        },
      },
      riskReduce: {
        list: {
          url: "/api/ram/charm/assess/riskReduce"
        },
      }
    },
    riskRegister: {
      list: {
        url: "/api/ram/riskRegisters/assess"
      },
    }
  },
  sop: {
    lim: {
      lincense: {
        kind: {
          list: {
            url: "/api/sop/lim/licensekinds"
          },
        },
        request: {
          list: {
            url: "/api/sop/lim/license/requests"
          },
          get: {
            url: "/api/sop/lim/license/request/{0}"
          },
        },
        review: {
          list: {
            url: "/api/sop/lim/license/reviews"
          },
          get: {
            url: "/api/sop/lim/license/review/{0}"
          },
        },
        card: {
          list: {
            url: "/api/sop/lim/license/cards"
          },
          get: {
            url: "/api/sop/lim/license/card/{0}"
          },
        },
        equipment: {
          list: {
            url: "/api/sop/lim/license/equipment/{0}"
          },
        },
        material: {
          list: {
            url: "/api/sop/lim/license/material/{0}"
          },
        },
      },
    },
    ibm: {
      improve: {
        others: {
          url: "/api/sop/ibm/improvement/others"
        },
        list: {
          url: "/api/sop/ibm/improvements"
        },
        get: {
          url: "/api/sop/ibm/improvement/{0}"
        },
        supple: {
          list: {
            url: "/api/sop/ibm/supple/improvements"
          },
        },
        status: {
          list: {
            url: "/api/sop/ibm/improvement/status"
          },
          task: {
            url: "/api/sop/ibm/improvement/task/status"
          },
          requestDept: {
            url: "/api/sop/ibm/improvement/requestDept/status"
          },
        },
        print: {
          url: "/api/sop/ibm/improvement/print"
        },
      },
      immediate: {
        get: {
          url: "/api/sop/ibm/immediate/{0}"
        },
      },
    },
    psr: {
      checkItem: {
        list: {
          url: "/api/sop/psr/prestartup/checkItems"
        },
        get: {
          url: "/api/sop/psr/prestartup/checkItem/{0}"
        },
      },
      check: {
        list: {
          url: "/api/sop/psr/prestartupChecks"
        },
        get: {
          url: "/api/sop/psr/prestartupCheck/{0}"
        },
        checkTypeItemList: {
          url: "/api/sop/psr/prestartupCheck/checkType/items"
        },
        checklistPrint: {
          url: "/api/sop/psr/prestartup/checklistPrint/{0}"
        },
        checklistReportPrint: {
          url: "/api/sop/psr/prestartup/checklistReportPrint/{0}"
        },
      },
      checkItemImprove: {
        list: {
          url: "/api/sop/psr/prestartup/improves"
        },
      }
    },
    swp: {
      workChekItem: {
        list: {
          url: "/api/sop/swp/checkItems"
        },
      },
      gas: {
        list: {
          url: "/api/sop/swp/gases"
        },
      },
      map: {
        list: {
          url: "/api/sop/swp/maps"
        },
        recent: {
          url: "/api/sop/swp/map/recent"
        },
      },
      workPermit: {
        list: {
          url: "/api/sop/swp/workPermits"
        },
        get: {
          url: "/api/sop/swp/workPermit/{0}"
        },
        print: {
          url: "/api/sop/swp/workPermit/print/{0}"
        },
        prints: {
          url: "/api/sop/swp/workPermit/prints"
        },
        sopAssessment: {
          default: {
            url: "/api/sop/swp/workPermit/sopAssessment/default"
          },
        }
      },
    },
    moc: {
      change: {
        list: {
          url: "/api/sop/moc/mocs"
        },
        get: {
          url: "/api/sop/moc/moc/{0}"
        },
        status: {
          url: "/api/sop/moc/mocStatus"
        },
        judgeCheckList: {
          base: {
            url: "/api/sop/moc/moc/judgeCheckList/base"
          },
          get: {
            url: "/api/sop/moc/moc/judgeCheckList/{0}"
          },
        },
        initiative: {
          get: {
            url: "/api/sop/moc/moc/initiative/{0}"
          },
        },
        review: {
          get: {
            url: "/api/sop/moc/moc/review/{0}"
          },
        },
        committee: {
          list: {
            url: "/api/sop/moc/moc/committees"
          },
        },
        reviewItem: {
          list: {
            url: "/api/sop/moc/moc/committee/reviewItems"
          },
        },
        action: {
          get: {
            url: "/api/sop/moc/moc/action/{0}"
          },
        },
        punchList: {
          get: {
            url: "/api/sop/moc/moc/punchList/{0}"
          },
        },
        emergency: {
          initiative: {
            get: {
              url: "/api/sop/moc/moc/emergency/initiative/{0}"
            },
          },
        },
        approvalFlag: {
          get: {
            url: "/api/sop/moc/moc/approvalFlag/{0}"
          },
        },
      },
      relationWorkDocu: {
        case1: {
          list: {
            url: "/api/sop/moc/relationWork/documentPSI"
          },
        },
        case2: {
          list: {
            url: "/api/sop/moc/relationWork/documentRSA"
          },
        },
        case3: {
          list: {
            url: "/api/sop/moc/relationWork/documentEDU"
          },
        },
        case4: {
          list: {
            url: "/api/sop/moc/relationWork/documentPSR"
          },
        },
        case5: {
          list: {
            url: "/api/sop/moc/relationWork/documentSWP"
          },
        },
      },
      determination: {
        list: {
          url: "/api/sop/moc/determination/checklists"
        },
      }
    },
    min: {
      equipment: {
        annual: {
          list: {
            url: "/api/sop/min/equipment/annual"
          },
          get: {
            url: "/api/sop/min/equipment/annual/{0}/{1}"
          },
        },
        plan: {
          daily: {
            list: {
              url: "/api/sop/min/equipment/daily/plans"
            },
            get: {
              url: "/api/sop/min/equipment/daily/plan/{0}"
            }
          },
          deterior: {
            list: {
              url: "/api/sop/min/equipment/deterior/plans"
            },
            get: {
              url: "/api/sop/min/equipment/deterior/plan/{0}"
            },
          }
        },
        result : {
          daily: {
            list: {
              url: "/api/sop/min/equipment/daily/results"
            },
            newItem: {
              url: "/api/sop/min/equipment/daily/new/result/{0}"
            },
            utilityItem: {
              url: "/api/sop/min/equipment/daily/utility/result"
            }
          },
          deterior: {
            list: {
              url: "/api/sop/min/equipment/deterior/results"
            },
            newItem: {
              url: "/api/sop/min/equipment/deterior/new/result/{0}"
            },
          },
          lunar: {
            url: "/api/sop/min/equipment/lunar/{0}"
          }
        },
        checkCycle: {
          list: {
            url: "/api/sop/min/equipment/checkcycle"
          }
        },
        maintain: {
          list: {
            url: "/api/sop/min/equipment/maintain/maintains"
          },
          getYear: {
            url: "/api/sop/min/equipment/maintain/maintain/year"
          },
          print: {
            url: "/api/sop/min/equipment/maintain/maintain/print"
          }
        },
        improve: {
          get: {
            url: "/api/sop/min/equipment/improve/{0}/{1}"
          }
        }
      },
      maintenance: {
        plan: {
          list: {
            url: "/api/sop/min/maintenance/plans"
          },
          get: {
            url: "/api/sop/min/maintenance/plan/{0}"
          }
        },
        result : {
          list: {
            url: "/api/sop/min/maintenance/results"
          },
        },
      },
    },
    safetycheck: {
      item: {
        list: {
          url: "/api/sop/min/safetycheck/items"
        }
      },
      plan: {
        list: {
          url: "/api/sop/min/safetycheck/plans"
        },
        get: {
          url: "/api/sop/min/safetycheck/plan/{0}"
        }
      },
      result: {
        newItem: {
          url: "/api/sop/min/safetycheck/result/new/{0}"
        }
      },
      improve: {
        get: {
          url: "/api/sop/min/safetycheck/improve/{0}/{1}"
        }
      }
    },
    hhm: {
      hazard: {
        check: {
          list: {
            url: "/api/sop/hhm/hazard/equipments"
          },
          get: {
            url: "/api/sop/hhm/hazard/equipment/{0}"
          },
          check: {
            url: "/api/sop/hhm/hazard/equipment/check"
          },
        },
        hazardHistory: {
          get: {
            url: "/api/sop/hhm/hazard/equipment/history/{0}"
          },
        },
        hazardImprove: {
          get: {
            url: "/api/sop/hhm/hazard/equipment/improve/{0}/{1}"
          },
        },
        master: {
          item: {
            list: {
              url: "/api/sop/hhm/hazard/items"
            },
            common: {
              url: "/api/sop/hhm/hazard/common/items"
            },
          }
        },
        focus: {
          info: {
            list: {
              url: "/api/sop/hhm/hazard/focus/inspections"
            },
            get: {
              url: "/api/sop/hhm/hazard/focus/inspection/{0}"
            }
          }
        }
      },
    },
    edu: {
      course: {
        list: {
          url: "/api/sop/edu/course/infos"
        },
        get: {
          url: "/api/sop/edu/course/info/{0}"
        },
        check: {
          url: "/api/sop/edu/course/info/check/{0}/{1}/{2}"
        }
      },
      attendee: {
        get: {
          url: "/api/sop/edu/course/attendees/{0}"
        },
      },
      yearEdu: {
        get: {
          url: "/api/sop/edu/annual/yearEdu"
        }
      },
      annual: {
        list: {
          url: "/api/sop/edu/annual/plans"
        },
        get: {
          url: "/api/sop/edu/annual/plan/{0}"
        },
        trend: {
          list: {
            url: "/api/sop/edu/annual/trend"
          },
          get: {
            url: "/api/sop/edu/annual/trend/data"
          },
        },
        trendgraph: {
          list: {
            url: "/api/sop/edu/annual/trend/graph"
          },
          get: {
            url: "/api/sop/edu/annual/trend/graph/detail"
          },
        },
      },
      result: {
        list: {
          url: "/api/sop/edu/results"
        },
        get: {
          url: "/api/sop/edu/result/{0}",
          targetUser: {
            url: "/api/sop/edu/result/targetuser/{0}",
          },
          mobile: {
            url: "/api/sop/edu/result/mobile/{0}/{1}"
          }
        },
        print: {
          second: {
            url: "/api/sop/edu/result/print/second",
          },
          third: {
            url: "/api/sop/edu/result/print/third",
          },
        },
        certificate: {
          url: "/api/sop/edu/result/certificate/{0}",
        }
      },
      user: {
        list: {
          url: "/api/sop/edu/users"
        }
      },
      target: {
        users: {
          url: "/api/sop/edu/targetusers"
        }
      },
      arrivaldate: {
        list: {
          url: "/api/sop/edu/arrivaldate/users"
        }
      }
    },
    iim: {
      occurForm: {
        list: {
          url: "/api/sop/iim/occur/forms"
        },
        get: {
          url: "/api/sop/iim/occur/form/{0}"
        }
      },
      accident: {
        near: {
          list: {
            url: "/api/sop/iim/accident/nears"
          },
          get: {
            url: "/api/sop/iim/accident/near/{0}"
          },
          prevention: {
            get: {
              url: "/api/sop/iim/accident/near/prevention/{0}",
            },
          },
        },
        process: {
          list: {
            url: "/api/sop/iim/accident/processes"
          },
          investigation: {
            get: {
              url: "/api/sop/iim/accident/process/investigation/{0}",
            },
            victim: {
              get: {
                url: "/api/sop/iim/accident/process/investigation/victim/{0}",
              }
            }
          },
          prevention: {
            get: {
              url: "/api/sop/iim/accident/process/prevention/{0}",
            }
          },
          get: {
            url: "/api/sop/iim/accident/process/{0}",
          }
        },
        report: {
          get: {
            url: "/api/sop/iim/accident/process/report/{0}",
          },
          print: {
            url: "/api/sop/iim/accident/process/print/{0}",
          }
        },
        status: {
          year: {
            url: "/api/sop/iim/accident/status/year",
            dept: {
              url: "/api/sop/iim/accident/status/dept/year",
            }
          },
          hour: {
            url: "/api/sop/iim/accident/status/hour",
          },
          season: {
            url: "/api/sop/iim/accident/status/season",
          },
          kind1: {
            url: "/api/sop/iim/accident/status/kind1",
          },
          kind2: {
            url: "/api/sop/iim/accident/status/kind2",
          },
        }
      }
    },
    eap: {
      base: {
        list: {
          url: "/api/sop/eap/eval/items"
        },
      },
      relation: {
        list: {
          url: "/api/sop/eap/eval/relations"
        }
      },
      planDocu: {
        list: {
          url: "/api/sop/eap/plan/docus",
          pop: {
           url: "/api/sop/eap/plan/pop/docus",
          }
        },
        get: {
          url: "/api/sop/eap/plan/docu/{0}"
        },
      },
      scenario: {
        list: {
          url: "/api/sop/eap/plan/scenarios"
        },
        get: {
          url: "/api/sop/eap/plan/scenario/{0}"
        },
        rev: {
          url: "/api/sop/eap/plan/scenario/revs/{0}",
          get: {
            url: "/api/sop/eap/plan/scenario/rev/{0}/{1}"
          }
        },
      },
      training: {
        plan: {
          list: {
            url: "/api/sop/eap/training/plans"
          },
          get: {
            url: "/api/sop/eap/training/plan/{0}"
          },
          getItem: {
            url: "/api/sop/eap/training/plan/items"
          },
        }
      }
    },
    opm: {
      folder: {
        list: {
          url: "/api/sop/opm/folders"
        },
        get: {
          url: "/api/sop/opm/folder/{0}"
        },
      },
      folderDetail: {
        list: {
          url: "/api/sop/opm/folder/details/{0}"
        },
        get: {
          url: "/api/sop/opm/folder/detail/{0}"
        },
        rev: {
          url: "/api/sop/opm/folder/detail/revs",
          get: {
            url: "/api/sop/opm/folder/detail/rev/{0}"
          }
        }
      },
      guidebook: {
        list: {
          url: "/api/sop/opm/guidebooks"
        },
        get: {
          url: "/api/sop/opm/guidebook/{0}"
        },
        rev: {
          url: "/api/sop/opm/guidebook/revs",
          get: {
            url: "/api/sop/opm/guidebook/rev/{0}"
          }
        }
      }
    },
    cto: {
      basic: {
        list: {
          url: "/api/sop/cto/infos"
        },
        get: {
          url: "/api/sop/cto/info/{0}"
        },
      },
      improve: {
        get: {
          url: "/api/sop/cto/info/improve"
        },
      },
      stdchecklist: {
        list: {
          url: "/api/sop/cto/std/checklists"
        },
        hierarchy: {
          url: "/api/sop/cto/std/checklists/hierarchy"
        },
      },
    }
  },
  mdm: {
    ghs: {
      nation: {
        list: '/api/mdm/ghs/nations',
      },
      mix: {
        list: '/api/mdm/ghs/mixs',
      },
      db: {
        list: '/api/mdm/ghs/dbs',
      }
    },
    deptmanager: {
      list: {
        url: "/api/mdm/dept/managers"
      },
    },
    law: {
      list: {
        url: "/api/mdm/law/laws"
      },
    },
    lawManager: {
      list: {
        url: "/api/mdm/law/lawManagers"
      },
    },
    cim: {
      vendor: {
        list: {
          url: "/api/mdm/cim/vendors"
        },
        get: {
          url: "/api/mdm/cim/vendor/{0}"
        },
        check: {
          url: "/api/mdm/cim/vendor/check/{0}"
        },
        user: {
          list: {
            url: "/api/mdm/cim/vendorusers"
          },
        },
        item: {
          list: {
            url: "/api/mdm/cim/vendoreval/items"
          },
        },
        type: {
          list: {
            url: "/api/mdm/cim/vendoreval/types"
          },
        },
        attach: {
          list: {
            url: "/api/mdm/cim/vendor/attacies"
          },
        },
        evaluation: {
          result: {
            list: {
              url: "/api/mdm/cim/vendoreval/results"
            },
            get: {
              url: "/api/mdm/cim/vendoreval/result/{0}"
            },
            item: {
              url: "/api/mdm/cim/vendoreval/resultitems"
            },
            user: {
              url: "/api/mdm/cim/vendoreval/resultusers"
            },
            history: {
              url: "/api/mdm/cim/vendoreval/resulthistory"
            },
          },
        },
        council: {
          list: {
            url: "/api/sop/vendor/councils"
          },
          get: {
            url: "/api/sop/vendor/council/{0}"
          }
        }
      },
    },
    mam: {
      material: {
        list: {
          url: "/api/mdm/mam/materials"
        },
        get: {
          url: "/api/mdm/mam/material/{0}"
        },
        check: {
          url: "/api/mdm/mam/material/check/{0}"
        },
      },
      rule: {
        list: {
          url: "/api/mdm/mam/rule/rules"
        },
        get: {
          url: "/api/mdm/mam/rule/rule"
        },
        chems: {
          url: "/api/mdm/mam/rule/chems"
        },
      },
      chem: {
        listreg: {
          url: "/api/mdm/mam/chemregs"
        },
        list: {
          url: "/api/mdm/mam/chem/materials"
        },
        get: {
          url: "/api/mdm/mam/chem/material/{0}"
        },
        regulate: {
          url: "/api/mdm/mam/chem/regulate/{0}"
        },
        header: {
          url: "/api/mdm/mam/chem/header",
          value: {
            url: "/api/mdm/mam/chem/header/vals"
          },
        },
        check: {
          url: "/api/mdm/mam/chem/check/material"
        },
        regs: {
          url: "/api/mdm/mam/chem/regs"
        },
        dept: {
          url: "/api/mdm/mam/chem/depts"
        },
        process: {
          url: "/api/mdm/mam/chem/processs"
        },
        processname: {
          url: "/api/mdm/mam/chem/processnames"
        },
        byprocess: {
          url: "/api/mdm/mam/chem/byprocess"
        },
        substance: {
          regulate: {
            url: "/api/mdm/mam/chem/substance/regulate",
            nation: {
              url: "/api/mdm/mam/chem/substance/regulate/nation"
            },
          },
          url: "/api/mdm/mam/chem/substances"
        },
        hazard: {
          url: "/api/mdm/mam/chem/hazard"
        },
        license: {
          url: "/api/mdm/mam/chem/license"
        },
        msds: {
          url: "/api/mdm/mam/chem/msds"
        }
      },
      regulation: {
        item: {
          list: {
            url: "/api/mdm/mam/regulation/items"
          },
          get: {
            url: "/api/mdm/mam/regulation/item/{0}"
          },
        },
      },
    },
    sop: {
      job: {
        list: {
          url: "/api/mdm/sop/sops"
        },
        get: {
          url: "/api/mdm/sop/sop/{0}"
        },
      },
      step: {
        url: "/api/mdm/sop/steps/{0}"
      },
      hazard: {
        url: "/api/mdm/sop/hazards/{0}/{1}"
      },
      jobstep: {
        url: "/api/mdm/sop/sopsteps"
      },
      jobhazard: {
        url: "/api/mdm/sop/sophazards"
      },
      jobhazardreason: {
        url: "/api/mdm/sop/sophazardreasons"
      },
      processHazard: {
        url: "/api/mdm/sop/sopprocesshazards"
      },
      processHazardReason: {
        url: "/api/mdm/sop/sopprocesshazardreasons"
      },
      sopHazard: {
        url: "/api/mdm/sop/processsophazard"
      },
      mm: {
        list: {
          url: "/api/mdm/sop/mms"
        },
      },
      chems: {
        list: {
          url: "/api/mdm/sop/chems"
        },
      },
    },
    user: {
      list: {
        url: "/api/mdm/hrm/users"
      },
      get: {
        url: "/api/mdm/hrm/user/{0}"
      },
      check: {
        loginid: {
          url: "/api/mdm/hrm/user/check/loginid"
        }
      },
    },
    dept: {
      list: {
        url: "/api/mdm/dim/depts"
      },
      get: {
        url: "/api/mdm/dim/dept/{0}"
      },
      check: {
        url: "/api/mdm/dim/dept/check/{0}"
      }
    },
    process: {
      list: {
        url: "/api/mdm/pim/processes"
      },
      get: {
        url: "/api/mdm/pim/process/{0}"
      },
      nameget: {
        url: "/api/mdm/pim/processnames/{0}"
      },
      nameObject: {
        url: "/api/mdm/pim/processnames"
      },
      check: {
        url: "/api/mdm/pim/process/check/{0}"
      }
    },
    line: {
      list: {
        url: "/api/mdm/line/lines"
      },
      process: {
        list: {
          url: "/api/mdm/line/process/lines"
        },
      },
    },
    place: {
      list: {
        url: "/api/mdm/line/places"
      },
      process: {
        list: {
          url: "/api/mdm/line/process/places"
        },
      },
    },
    equipment: {
      qrUrl: {
        url: "/api/mdm/fim/equipment/qr"
      },
      list: {
        url: "/api/mdm/fim/equipments"
      },
      get: {
        url: "/api/mdm/fim/equipment"
      },
      check: {
        url: "/api/mdm/fim/equipment/check/{0}"
      },
      spec: {
        list: {
          url: "/api/mdm/fim/equipment/specs"
        },
      },
      daily: {
        list: {
          url: "/api/mdm/fim/equipment/dailys"
        }
      },
      deterior: {
        list: {
          url: "/api/mdm/fim/equipment/deteriors"
        }
      },
      material: {
        list: {
          url: "/api/mdm/fim/equipment/materials"
        },
      },
      rank: {
        list: {
          url: "/api/mdm/fim/equipment/ranks"
        },
        get: {
          url: "/api/mdm/fim/equipment/rank"
        },
      },
      class: {
        list: {
          url: "/api/mdm/equipment/classess"
        },
        get: {
          url: "/api/mdm/equipment/class/{0}/{1}"
        },
        check: {
          url: "/api/mdm/equipment/class/check/{0}/{1}"
        },
        insItem: {
          list: {
            url: "/api/mdm/equipment/class/insitems/{0}/{1}"
          },
        },
        infoItem: {
          list: {
            url: "/api/mdm/equipment/class/infoitems"
          },
        },
        item: {
          daily: {
            list: {
              url: "/api/mdm/equipment/daily/items/{0}/{1}"
            },
          },
          deterior: {
            list: {
              url: "/api/mdm/equipment/deterior/items/{0}/{1}"
            },
          },
        },
      },
      spareParts: {
        list: {
          url: '/api/mdm/equipment/spareparts',
        },
      },
      psm: {
        list: {
          url: '/api/mdm/fim/equipment/psm',
        },
      },
      license: {
        list: {
          url: '/api/mdm/fim/equipment/license',
        },
      },
    },
    senior: {
      list: {
        url: '/api/mdm/senior/seniors',
      },
      status: {
        list: {
          url: "/api/mdm/senior/statuses"
        },
        get: {
          url: "/api/mdm/senior/status/{0}"
        },
        rev: {
          url: "/api/mdm/senior/status/revs",
          get: {
            url: "/api/mdm/senior/status/rev/{0}"
          }
        }
      }
    }
  },
  sai: {
    uninjury: {
      list: {
        url: "/api/sai/uninjurys"
      },
      get: {
        url: "/api/sai/uninjury"
      }
    },
    penalty: {
      list: {
        url: "/api/sai/penalty/penaltylist"
      },
      get: {
        url: "/api/sai/penalty/penaltys"
      }
    },
    tbm: {
      list: {
        url: "/api/sai/tbm/tbms"
      },
      get: {
        url: "/api/sai/tbm/tbm/{0}",
        equip: {
          result: {
            url: "/api/sai/tbm/equip/result/{0}",
          }
        }
      },
      print: {
        url: "/api/sai/tbm/print/{0}"
      },
      respond: {
        url: "/api/sai/tbm/respond/{0}/{1}"
      }
    },
    hazard: {
      list: {
        url: "/api/sai/hazard/hazards",
        dept: {
          url: "/api/sai/hazard/hazard/depts",
          checkup: {
            url: "/api/sai/hazard/hazard/checkup/depts"
          }
        },
      },
      get: {
        url: "/api/sai/hazard/hazard/{0}",
        dept: {
          url: "/api/sai/hazard/hazard/dept/{0}"
        }
      },
      check: {
        url: "/api/sai/hazard/hazard/check"
      },
      substance: {
        list: {
          url: "/api/sai/hazard/hazard/substances"
        }
      },
      master: {
        list: {
          url: "/api/sai/hazard/masters"
        }
      },
      dept: {
        user: {
          url: "/api/sai/hazard/hazard/dept/users"
        },
        type: {
          list: {
            url: "/api/sai/hazard/hazard/dept/types"
          },
          factor: {
            url: "/api/sai/hazard/hazard/dept/type/factors"
          },
          user: {
            url: "/api/sai/hazard/hazard/dept/type/users"
          }
        }
      }
    },
    workmeas: {
      plan: {
        list: {
          url: "/api/sai/work/plans"
        },
        get: {
          url: "/api/sai/work/plan/{0}",
        },
        check: {
          url: "/api/sai/work/plan/check/{0}/{1}/{2}",
        },
      },
      result: {
        list: {
          url: "/api/sai/work/results"
        },
        get: {
          url: "/api/sai/work/result/{0}",
        },
        chart: {
          url: "/api/sai/work/result/chart"
        },
        factor: {
          url: "/api/sai/work/result/factor"
        }
      }
    },
    osh: {
      proceedings: {
        list: {
          url: "/api/sai/osh/proceedings"
        },
        get: {
          url: "/api/sai/osh/proceedings/{0}"
        }
      }
    },
    shm: {
      policy: {
        list: {
          url: "/api/sai/shm/policies"
        },
        get: {
          url: "/api/sai/shm/policy/{0}"
        }
      }
    },
    sob: {
      board: {
        list: {
          url: "/api/sai/sob/boards"
        },
        get: {
          url: "/api/sai/sob/board/{0}"
        }
      }
    },
    patrol: {
      resultItem: {
        list: {
          url: "/api/sai/patrol/result/items",
        },
        place: {
          url: "/api/sai/patrol/result/item/place",
          line: {
            url: "/api/sai/patrol/result/item/place/lines",
          }
        },
      },
      list: {
        url: "/api/sai/patrol/patrols"
      },
      get: {
        url: "/api/sai/patrol/patrol/{0}",
      },
      print: {
        url: "/api/sai/patrol/patrol/print/{0}",
      },
      place: {
        get: {
          url: "/api/sai/patrol/patrol/place/{0}",
        },
      },
      improve: {
        url: "/api/sai/patrol/patrolImproves"
      },
    }
  },
  hea: {
    disease: {
      list: {
        url: "/api/hea/checkup/diseases"
      },
      check: {
        url: "/api/hea/checkup/check/disease"
      }
    },
    examine: {
      list: {
        url: "/api/hea/checkup/examines"
      },
      check: {
        url: "/api/hea/checkup/check/examine"
      }
    },
    checkup:{
      plan: {
        list: {
          url: "/api/hea/checkup/plans"
        },
        get: {
          url: "/api/hea/checkup/plan/{0}"
        },
        target:{
          users: {
            url: "/api/hea/checkup/target/users"
          }
        },
        print: {
          url: "/api/hea/checkup/plan/print/{0}"
        }
      },
      result: {
        list: {
        url: "/api/hea/checkup/results/{0}"
        },
        get: {
          url: "/api/hea/checkup/result/{0}"
        },
        status: {
          url: "/api/hea/checkup/status/results"
        }
      },
      suspect: {
        user: {
          list: {
            url: "/api/hea/suspect/users",
          },
          get: {
            url: "/api/hea/suspect/user/{0}",
          },
          target: {
            url: "/api/hea/suspect/user/target",
          }
        },
        consult: {
          list: {
            url: "/api/hea/suspect/consults",
          },
          get: {
            url: "/api/hea/suspect/consult/{0}",
          }
        },
        history: {
          consult: {
            url: "/api/hea/suspect/history/consults",
          },
          examine: {
            url: "/api/hea/suspect/history/examines",
          },
        },
        graph: {
          dept: {
            url: "/api/hea/suspect/graph/dept",
          },
          disease: {
            url: "/api/hea/suspect/graph/disease",
          },
          hazard: {
            url: "/api/hea/suspect/graph/hazard",
          },
        }
      }
    },
  },
  env: {
    danger: {
      master: {
        list: {
          url: "/api/env/danger/masters"
        },
        get: {
          url: "/api/env/danger/master/{0}"
        },
      },
      journal: {
        list: {
          url: "/api/env/danger/journals"
        },
        get: {
          url: "/api/env/danger/journal/{0}"
        },
        result: {
          url: "/api/env/danger/journal/results"
        }
      },
    },
    patrol: {
      item: {
        list: {
          url: "/api/env/patrol/items"
        }
      },
      list: {
        url: "/api/env/patrol/patrols"
      },
      get: {
        url: "/api/env/patrol/patrol/{0}"
      },
    },
    facility: {
      list: {
        url: "/api/env/hcf/facilities"
      },
      get: {
        url: "/api/env/hcf/facility/{0}"
      },
      process: {
        url: "/api/env/hcf/facility/processes"
      },
    },
    facilityInspectionClass: {
      list: {
        url: "/api/env/hcf/facility/inspectionClasses"
      },
    },
    facilityCheckItem: {
      list: {
        url: "/api/env/hcf/facility/checkItems"
      },
    },
    facilitySelfCheck: {
      list: {
        url: "/api/env/hcf/facility/selfChecks"
      },
      get: {
        url: "/api/env/hcf/facility/selfCheck/{0}"
      },
      item: {
        url: "/api/env/hcf/facility/default/selfCheckItemResults"
      },
      print: {
        url: "/api/env/hcf/facility/print/selfCheck/{0}"
      },
      prints: {
        url: "/api/env/hcf/facility/prints/selfCheck"
      },
      weeks: {
        url: "/api/env/hcf/facility/selfCheckWeeks"
      },
      recent: {
        url: "/api/env/hcf/facility/recent/selfCheck"
      }
    },
    facilitySelfCheckItem: {
      list: {
        url: "/api/env/hcf/facility/selfCheckItems"
      },
    },
    gov: {
      mst: {
        list: {
          url: "/api/env/gov/sch/msts"
        },
        get: {
          url: "/api/env/gov/sch/mst"
        },
      },
      user: {
        list: {
          url: "/api/env/gov/sch/users"
        },
      },
      history: {
        list: {
          url: "/api/env/gov/sch/historys"
        },
        get: {
          url: "/api/env/gov/sch/history"
        },
      },
    },
    water: {
      trust: {
        list: {
          url: "/api/env/water/trusts"
        },
        get: {
          url: "/api/env/water/trust"
        },
        check: {
          url: "/api/env/water/trust/check"
        },
        uc: {
          url: "/api/env/water/trust/uc"
        },
      },
    },
    waste: {
      mst: {
        list: {
          url: "/api/env/waste/msts"
        },
        get: {
          url: "/api/env/waste/mst"
        },
      },
      volume: {
        list: {
          url: "/api/env/waste/volumes"
        },
        get: {
          url: "/api/env/waste/volume"
        },
        empty: {
          url: "/api/env/waste/volume/empty"
        },
        check: {
          url: "/api/env/waste/volume/check"
        },
        uc: {
          url: "/api/env/waste/volume/uc"
        },
      },
    },
    air: {
      mst: {
        outlet: {
          list: {
            url: "/api/env/air/mst/outlets"
          },
          get: {
            url: "/api/env/air/mst/outlet"
          },
          discharge: {
            url: "/api/env/air/mst/outlet/discharges"
          },
          discharge2: {
            url: "/api/env/air/mst/outlet/dischargelists"
          },
          part: {
            url: "/api/env/air/mst/outlet/parts",
            status: "/api/env/air/mst/outlet/parts/status",
          },
          inspect: {
            url: "/api/env/air/mst/outlet/inspects"
          },
        },
        inspect: {
          list: {
            url: "/api/env/air/mst/inspects"
          },
          get: {
            url: "/api/env/air/mst/inspect"
          },
          plant: {
            url: "/api/env/air/mst/inspect/plants"
          },
        },
        history: {
          list: {
            url: "/api/env/air/mst/outlet/part/historys"
          },
          get: {
            url: "/api/env/air/mst/outlet/part/history"
          },
        }
      },
      self: {
        measure: {
          list: {
            url: "/api/env/air/self/measures"
          },
          get: {
            url: "/api/env/air/self/measure"
          },
          graph: {
            url: "/api/env/air/self/measure/graph"
          }
        },
        outlet: {
          list: {
            url: "/api/env/air/self/measure/outlets"
          },
          header: {
            url: "/api/env/air/self/measure/outlet/headers"
          },
        },
      }
    }
  },
  chm: {
    base: {
      dangerItem: {
        list: {
          url: "/api/chm/base/dangerItems"
        },
      }
    },
    inout: {
      list: {
        url: "/api/chm/inoutManages"
      },
      status: {
        url: "/api/chm/inoutManages/status"
      },
      print: {
        url: "/api/chm/inoutManage/print"
      },
    },
    knowhow: {
      list: {
        url: "/api/chm/knowhows"
      },
      get: {
        url: "/api/chm/knowhow"
      },
      print: {
        url: "/api/chm/knowhow/print/{0}"
      },
    },
    mail: {
      regulManager: {
        list: {
          url: "/api/chm/mail/regulManagers"
        },
      },
      nationManager: {
        list: {
          url: "/api/chm/mail/nationManagers"
        },
      },
    },
  },
  kosha: {
    folder: {
      list: {
        url: "/api/kosha/kosha/folders"
      },
      get: {
        url: "/api/kosha/kosha/folder/{0}"
      },
    },
    folderDetail: {
      list: {
        url: "/api/kosha/kosha/folder/details/{0}"
      },
      get: {
        url: "/api/kosha/kosha/folder/detail/{0}"
      },
      rev: {
        url: "/api/kosha/kosha/folder/detail/revs",
        get: {
          url: "/api/kosha/kosha/folder/detail/rev/{0}"
        }
      }
    },
    guidebook: {
      list: {
        url: "/api/kosha/kosha/guidebooks"
      },
      get: {
        url: "/api/kosha/kosha/guidebook/{0}"
      },
      rev: {
        url: "/api/kosha/kosha/guidebook/revs",
        get: {
          url: "/api/kosha/kosha/guidebook/rev/{0}"
        }
      }
    }
  }
};

export default selectConfig;
